import React from 'react';
import { connect } from 'react-redux'
import { Redirect } from 'react-router-dom'
import {Helmet} from 'react-helmet';
import { setActivitiesOpen } from '../../../actions/create-action'
import { Link } from 'react-router-dom';
import Rolling from '../../../Images/rolling.svg';

import Menu from '../../Navigation/Menu'
import { store } from '../../../store';

import Navigation from '../../Navigation/Navigation';
import Footer from '../../Footer/Footer';
import {Grid, Row, Col} from 'react-bootstrap';
import ImageTab from '../../../Images/second_tab.jpg';
const mapStateToProps = (state) => {
  let open = state.activities.open
  return {
    open: open,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    onOpen: (open) => dispatch(setActivitiesOpen(open)),
  }
}

class Premium extends React.Component {
   constructor(props) {
      super()
      this.state = {
         visible:false,
         mouseOverbtn: false,
         clickInside: false,
         imgload: 'loading'
      }
      this.myRef=null
    this.handleClickOutside = this.handleClickOutside.bind(this)
    this.onMenu = this.onMenu.bind(this)
   }
   componentWillMount() {
      this.setState({visible: true})
   }
   componentWillLeave() {
      this.setState({visible: false})
   }
   componentDidMount() {
    document.addEventListener('mousedown', this.handleClickOutside)
  }
   componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside);
  }
  handleClickOutside(event) {
    if(this.wrapperRef && !this.wrapperRef.contains(event.target)) {
      return;
    }
    else if(!this.state.clickInside)
      this.props.onOpen('')
  }
  onImageLoad = () => {
    this.setState({imgload: 'loaded'})
  }
  onMenu = () => {
    if(store.getState().activities.open === 'menu')
    this.props.onOpen('')
    else this.props.onOpen('menu')
  }
  onClickInside = () => {
  this.setState({clickInside: true})
  }
  onClickOutside = () => {
    this.setState({clickInside: false})
  }
   render(props) {
      return (
         <div className="container_home" ref={this.setWrapperRef}>
         <Helmet>
          <title>Premium Profile</title>  
          <meta name="description" content="Switch to premium profile to get access into more exciting features" />
          <meta name="keyword" content="profile website, vieww profile, profiles, create onepage site, free profile, about vieww, create free profile page, professional profile, business profile" />
          <meta property="og:type" content="website" />
          <meta property="og:url" content="https://app.vieww.me/premium" />
          <meta property="og:title" content="Premium Profile" />
          <meta name="og:description" content="Switch to premium profile to get access into more exciting features" />
          <meta property="og:site_name" content="Premium Profile" />
          <meta property="twitter:card" content="summary_large_image" />
          <meta name="robots" content="index, follow" />
         </Helmet>
         <Grid fluid={true} className="container_light">
         <Row>
         <Col lg={12} md={12} sm={12} xs={12}>
         <Navigation
            onClickInside={this.onClickInside}
            onClickOutside={this.onClickOutside}
            onMenu={this.onMenu}
            location={this.props.location}/>
         </Col>
         <Col lg={10} md={10} sm={10} xs={12} className="light_inside">
         <h1>Premium Profile <badge className="cmg_sn">Comming Soon</badge></h1>
         <ul>
         <p>Create your complete profile with <strong>premium features</strong>. We're really excited in building this service for everyone to get the best out from it. Here are some core features which we're highlighting will be included with a premium account. This is not it, this is just the core ones; excluding these we will include more things which anyone of you will love using. Keep waiting, till then you can create your free account and get started with your profile!</p>
         <h2>Key Features</h2>
             <li><i class="fa fa-check f-in" aria-hidden="true"></i><strong>Custom domain</strong></li>
             <li><i class="fa fa-check f-in" aria-hidden="true"></i><strong>Forms</strong> - subscription, contact, feedback etc.</li>
             <li><i class="fa fa-check f-in" aria-hidden="true"></i><strong>Portfolio</strong> - Add pictures & albums</li>
             <li><i class="fa fa-check f-in" aria-hidden="true"></i><strong>Premium Themes</strong></li>
         </ul>
         <p>Right now, get your profile ready for premium by creating one now for free.</p>
         <div className="hl_btn_container_content">
         <Link className="top_btn" to={'/create'}>Get started</Link>
        </div>
         </Col>
         </Row>
         </Grid>
         <Footer location={this.props.location} />
         {store.getState().activities.open === 'menu'
            ? <Menu
            onClickInside={this.onClickInside}
            onClickOutside={this.onClickOutside}
            onOpen={this.props.onOpen} />
            : null
          }
         </div>
      );
   }
}

export default connect(mapStateToProps, mapDispatchToProps)(Premium);